import { lazy } from "react";
import { connect } from "react-redux";

import { getFetchRoles } from "../../../../hooks/Security/Users/getFetchRoles";
import { getFetchUsers } from "../../../../hooks/Security/Users/useFetchUser";
import { getFetchModules } from "../../../../hooks/Security/Users/getFetchModules";
import { getFetchModulesByUser } from "../../../../hooks/Security/Users/getFetchModulesByUser";
import { getAllEmployees } from "../../../../hooks/Administration/Employees/getAllEmployees";

const ShowUser = lazy(() => import("./ShowUser"));

const mapStateToProps = (state) => {
  return ({
    loading: state.security.user.loading,
    loadingAction: state.security.user.loadingAction,
    user: state.security.user.detail.data,

    loadingModules: state.security.user.modules.loading,
    modules: state.security.user.modules.data,

    loadingModulesByUser: state.security.user.moduleByUser.loading,
    modulesByUser: state.security.user.moduleByUser.data,

    loadingRole: state.security.user.roles.loading,
    roles: state.security.user.roles.data,

    loadingEmployess: state.administration.employees.loading,
    employess: state.administration.employees.data,
  })
};

const mapDispatchToProps = dispatch => ({
  getFetchUsers: (formData) => dispatch(getFetchUsers(formData)),
  getFetchRoles: (formData) => dispatch(getFetchRoles(formData)),
  getFetchModules: (formData) => dispatch(getFetchModules(formData)),
  getAllEmployees: (formData) => dispatch(getAllEmployees(formData)),
  getFetchModulesByUser: (formData) => dispatch(getFetchModulesByUser(formData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ShowUser);
